<template>
<div>
<p> We hope you enjoyed reading this book sample.<br/> Please click on any of the store links to buy it or the social links to recommend it.<br/> Thank you</p>
</div>
</template>
<script>
export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>


// WEBPACK FOOTER //
// last.vue?41e1075e